module.exports = __webpack_public_path__ + "static/media/logo_neuralnetwork.42079989.webp";